var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"news-list"},_vm._l((_vm.data),function(item,index){return _c('Item',{key:index,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }